<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import NavHeader from "@/components/general/NavHeader.vue";
import { appStore } from "@/stores/AppStore";

const route = useRoute();
const store = appStore();

const autoSignInOnDevice = async (): Promise<void> => {
  await store.autoSignInOnDevice("expedition");
};

const isExpeditionContainerView = computed(
  () => typeof route.name === "string" && route.name.includes("ExpeditionContainerView"),
);
autoSignInOnDevice();
</script>

<template>
  <div class="safe-area-bot min-h-screen bg-neutral-800 flex flex-col">
    <NavHeader v-if="!isExpeditionContainerView" app-name="expedition" title="Expedice" />
    <div
      class="flex flex-col flex-auto"
      :class="{
        'px-4 lg:px-8 py-6': !isExpeditionContainerView,
        // pokud je to view containeru, tak se přidá padding kvůli rozdílnému layoutu
      }"
    >
      <router-view />
      <DynamicDialog />
    </div>
  </div>
</template>
